module.exports = __webpack_public_path__ + "img/刑事.a1036baf.png";